var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_8834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.00391C8.63 2.00391 5.5 5.13991 5.5 9.01733C5.5 14.2774 12.5 22.0423 12.5 22.0423C12.5 22.0423 19.5 14.2774 19.5 9.01733C19.5 5.13991 16.37 2.00391 12.5 2.00391ZM7.5 9.01733C7.5 6.25204 9.74 4.00774 12.5 4.00774C15.26 4.00774 17.5 6.25204 17.5 9.01733C17.5 11.9029 14.62 16.2211 12.5 18.9163C10.42 16.2412 7.5 11.8728 7.5 9.01733Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.5223C13.8807 11.5223 15 10.4008 15 9.01749C15 7.63413 13.8807 6.5127 12.5 6.5127C11.1193 6.5127 10 7.63413 10 9.01749C10 10.4008 11.1193 11.5223 12.5 11.5223Z",
    fill: "#494949"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_8834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.046,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.9246defc69d34cb467ba0b2676d51e49.svg";
export { ForwardRef as ReactComponent };